
interface EventBreakdownProps {
  services: string[];
  equipment: string[];
}

export default function EventBreakdown({ services, equipment }: EventBreakdownProps) {
  return (
    <section className="py-20 bg-stone-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-px bg-emerald-400"></div>
          <span className="text-emerald-600 text-xs font-semibold tracking-[0.2em] uppercase">Project Breakdown</span>
        </div>
        <h2 className="text-3xl md:text-4xl font-display text-stone-900 mb-12">
          What We <span className="italic text-stone-400">Delivered</span>
        </h2>

        <div className="grid md:grid-cols-2 gap-8">
          {/* Services */}
          <div className="bg-white rounded-2xl border border-stone-100 p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-emerald-50 flex items-center justify-center">
                <i className="ri-service-line text-lg text-emerald-600"></i>
              </div>
              <h3 className="text-lg font-serif font-semibold text-stone-900">Services Provided</h3>
            </div>
            <div className="space-y-3">
              {services.map((service, idx) => (
                <div key={idx} className="flex items-center gap-3 group">
                  <div className="w-6 h-6 rounded-full bg-emerald-50 flex items-center justify-center flex-shrink-0 group-hover:bg-emerald-100 transition-colors">
                    <i className="ri-check-line text-xs text-emerald-600"></i>
                  </div>
                  <span className="text-stone-600 text-sm">{service}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Equipment */}
          <div className="bg-white rounded-2xl border border-stone-100 p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-teal-50 flex items-center justify-center">
                <i className="ri-tools-line text-lg text-teal-600"></i>
              </div>
              <h3 className="text-lg font-serif font-semibold text-stone-900">Equipment Used</h3>
            </div>
            <div className="space-y-3">
              {equipment.map((item, idx) => (
                <div key={idx} className="flex items-center gap-3 group">
                  <div className="w-6 h-6 rounded-full bg-teal-50 flex items-center justify-center flex-shrink-0 group-hover:bg-teal-100 transition-colors">
                    <i className="ri-checkbox-blank-circle-fill text-[6px] text-teal-500"></i>
                  </div>
                  <span className="text-stone-600 text-sm">{item}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
